import { render, staticRenderFns } from "./svgXhiame.vue?vue&type=template&id=558ee190"
import script from "./svgXhiame.vue?vue&type=script&lang=js"
export * from "./svgXhiame.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports